<template>
  <div v-if="detail != ''" class="container">
    <ul>
      <li>
        <label>项目名称：</label>
        <p>{{ detail.project_name }}</p>
      </li>
      <li>
        <label>网点设备：</label>
        <p>{{ detail.device_name }}</p>
      </li>
      <li>
        <label>机器类型：</label>
        <p v-show="detail.firm_id == 1">易触</p>
        <p v-show="detail.firm_id == 2">华屹1</p>
        <p v-show="detail.firm_id == 3">华屹2</p>
        <p v-show="detail.firm_id == 4">卡游</p>
      </li>
      <li>
        <label>网点地址：</label>
        <p>{{ detail.address }}</p>
      </li>
      <li>
        <label>员工：</label>
        <p>{{ detail.user_name }}</p>
      </li>
      <li>
        <label>工单创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>工单修改时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>状态：</label>
        <p v-show="detail.status == 10">待完成</p>
        <p v-show="detail.status == 1">待审核</p>
        <p v-show="detail.status == 2">已通过</p>
        <p v-show="detail.status == 3">已驳回</p>
      </li>
      <li>
        <label>工单类型：</label>
        <p v-show="detail.type == 1">补货</p>
        <p v-show="detail.type == 2">上新</p>
        <p v-show="detail.type == 3">美陈</p>
        <p v-show="detail.type == 10">临时</p>
      </li>
      <li v-show="detail.status == 3">
        <label>驳回原因：</label>
        <p>{{ detail.reason }}</p>
      </li>
      <li v-show="detail.status == 2 || detail.status == 3">
        <label>审核人：</label>
        <p>{{ detail.check_user_name }}</p>
      </li>
      <li v-show="detail.status == 2 || detail.status == 3">
        <label>审核时间：</label>
        <p>{{ detail.check_time }}</p>
      </li>
    </ul>
    <div class="operation">
      <a-button
        type="primary"
        @click="auditPagePass"
        v-show="detail.status == 1"
      >
        工单通过
      </a-button>
      <a-button
        type="danger"
        @click="auditPageReject"
        v-show="detail.status == 1"
      >
        工单驳回
      </a-button>
      <a-button type="primary" @click="setSettle">
        结算
      </a-button>
    </div>
    <!-- 结算信息 -->
    <section class="settleStyle">
      <h2>结算信息</h2>
      <ul>
        <li>
          <div>
            <label>预计甲方结算价：</label>
            <p>{{ Number(detail.pre_owner) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>预计员工结算价：</label>
            <p>{{ Number(detail.pre_guard) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>甲方奖励金额：</label>
            <p>{{ Number(detail.reward_owner) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>员工奖励金额：</label>
            <p>{{ Number(detail.reward_guard) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>甲方惩罚金额：</label>
            <p>{{ Number(detail.punish_owner) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>员工惩罚金额：</label>
            <p>{{ Number(detail.punish_guard) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>实际员工结算价：</label>
            <p>{{ Number(detail.price) + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>实际甲方结算价：</label>
            <p>{{ detail.owner_price + "元" }}</p>
          </div>
        </li>
        <li>
          <div>
            <label>结算备注：</label>
            <p>{{ detail.check_remark }}</p>
          </div>
        </li>
      </ul>
    </section>
    <!-- 结算信息 end -->
    <!-- 货道信息 -->
    <section
      v-if="(detail.type == 1 || detail.type == 2) && detail.firm_id == 1"
    >
      <h2>货道信息</h2>
      <table>
        <thead>
          <th>货道</th>
          <th>待下架商品</th>
          <th>商品图</th>
          <th>余量</th>
          <th>实际下架</th>
          <th>补货/上新商品</th>
          <th>商品图</th>
          <th>需补货</th>
          <th>实际补货/上新</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in detail.material_info" :key="index + 'g'">
            <td>{{ item.aisle }}</td>
            <td>{{ item.down_brand_name }}</td>
            <td>
              <div>
                <img :src="item.down_image_url.url_thumb" alt="" />
              </div>
            </td>
            <td>{{ item.remaining_no }}</td>
            <td>{{ item.down_brand_count }}</td>
            <td>{{ item.brand_name }}</td>
            <td>
              <div>
                <img :src="item.image_url.url_thumb" alt="" />
              </div>
            </td>
            <td>{{ item.supplement_no }}</td>
            <td>{{ item.count }}</td>
          </tr>
          <tr v-show="detail.material_info == ''">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>暂无</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </section>
    <!-- 货道信息 end-->
    <!-- 卡游数据 -->
    <section
      class="kyFormList"
      v-if="(detail.type == 1 || detail.type == 2) && detail.firm_id == 4"
    >
      <h2 v-show="detail.type == 1">上新</h2>
      <h2 v-show="detail.type == 2">补货</h2>
      <div v-for="(item, idx) in detail.material_info" :key="idx + 'a'">
        <h3 v-show="item.up_list != ''">
          {{ "机器编号：" + item.machine_id }}
        </h3>
        <table v-show="item.up_list != ''">
          <thead>
            <th>商品名称</th>
            <th>商品图</th>
            <th>需补货</th>
            <th>实际补货</th>
          </thead>
          <tbody>
            <tr v-for="(element, k) in item.up_list" :key="k + 'r'">
              <td>{{ element.brand_name }}</td>
              <td>
                <img class="imgStyle" :src="element.image_url.url" />
              </td>
              <td>{{ element.total_supplement_no }}</td>
              <td>{{ element.total_count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section
      class="kyFormList"
      v-if="(detail.type == 1 || detail.type == 2) && detail.firm_id == 4"
    >
      <h2>下架</h2>
      <div v-for="(item, idx) in detail.material_info" :key="idx + 't'">
        <h3 v-show="item.down_list != ''">
          {{ "机器编号：" + item.machine_id }}
        </h3>
        <table v-show="item.down_list != ''">
          <thead>
            <th>商品名称</th>
            <th>商品图</th>
            <th>余量</th>
            <th>实际下架</th>
          </thead>
          <tbody>
            <tr v-for="(element, k) in item.down_list" :key="k + 'o'">
              <td>{{ element.down_brand_name }}</td>
              <td>
                <img class="imgStyle" :src="element.image_url.url" />
              </td>
              <td>{{ element.total_remaining_no }}</td>
              <td>{{ element.down_total_count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <!-- 卡游数据 end -->
    <!-- 图片信息 -->
    <section v-show="detail.status != 10">
      <h2>工单照片</h2>
      <ul class="imgStyle">
        <li v-show="detail.type == 10">
          <label>临时工单附件</label>
          <viewer :images="detail.temp_image_url">
            <img
              class="imgStyle"
              v-for="src in detail.temp_image_url"
              :src="src.url"
              :key="src.url + 'p'"
            />
          </viewer>
        </li>
        <li v-show="detail.type == 1 || detail.type == 2">
          <label v-show="detail.type == 1">补货前：（通道+屏幕照片）</label>
          <label v-show="detail.type == 2">上新前：（通道+屏幕照片）</label>
          <viewer :images="detail.add_goods_before_url">
            <img
              class="imgStyle"
              v-for="src in detail.add_goods_before_url"
              :src="src.url"
              :key="src + 'a'"
            />
          </viewer>
        </li>
        <li v-show="detail.type == 1 || detail.type == 2">
          <label v-show="detail.type == 1">补货后：（通道+屏幕照片）</label>
          <label v-show="detail.type == 2">上新后：（通道+屏幕照片）</label>
          <viewer :images="detail.add_goods_after_url">
            <img
              class="imgStyle"
              v-for="src in detail.add_goods_after_url"
              :src="src.url"
              :key="src + 'b'"
            />
          </viewer>
        </li>
        <li v-show="detail.type == 1 || detail.type == 2">
          <label>设备清洁后：（点位机器整体照片）</label>
          <viewer :images="detail.clean_after_url">
            <img
              class="imgStyle"
              v-for="src in detail.clean_after_url"
              :src="src.url"
              :key="src + 'c'"
            />
          </viewer>
        </li>
        <li v-show="detail.type == 1 || detail.type == 2">
          <label>设备整体：（点位机器整体照片）</label>
          <viewer :images="detail.device_all_url">
            <img
              class="imgStyle"
              v-for="src in detail.device_all_url"
              :src="src.url"
              :key="src + 'd'"
            />
          </viewer>
        </li>
        <li v-show="detail.type == 3">
          <label>美陈</label>
          <viewer :images="detail.meichen_url">
            <img
              class="imgStyle"
              v-for="src in detail.meichen_url"
              :src="src.url"
              :key="src + 'f'"
            />
          </viewer>
        </li>
      </ul>
    </section>
    <!-- 图片信息 end -->
    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectIsShow = false">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
    <!-- 结算 -->
    <aside class="dialogsBox" v-show="settleHideIs">
      <div>
        <h3>结算</h3>
        <ul v-if="detail != ''">
          <li>
            <label>员工：</label>
            <span>{{ detail.name }}</span>
          </li>
          <li>
            <label>工单类型：</label>
            <span v-if="detail.type == 1">补货</span>
            <span v-else-if="detail.type == 2">上新</span>
            <span v-else-if="detail.type == 3">美陈</span>
            <span v-else-if="detail.type == 10">临时</span>
            <span v-else>未知</span>
          </li>
          <li>
            <label>甲方预计结算：</label>
            <span>{{ Number(detail.pre_owner) + "元" }}</span>
          </li>
          <li>
            <label>员工预计结算：</label>
            <span>{{ Number(detail.pre_guard) + "元" }}</span>
          </li>
          <li>
            <label><i>*</i>甲方奖励金额：</label>
            <a-input-number v-model="reward_owner" :min="0" />
            <span>&nbsp;元</span>
          </li>
          <li>
            <label><i>*</i>员工奖励金额：</label>
            <a-input-number v-model="reward_guard" :min="0" />
            <span>&nbsp;元</span>
          </li>
          <li>
            <label><i>*</i>甲方罚款金额：</label>
            <a-input-number v-model="punish_owner" :min="0" />
            <span>&nbsp;元</span>
          </li>
          <li>
            <label><i>*</i>员工罚款金额：</label>
            <a-input-number v-model="punish_guard" :min="0" />
            <span>&nbsp;元</span>
          </li>
          <li>
            <label>备注：</label>
            <a-textarea
              v-model="check_remark"
              style="width:70%"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </li>
        </ul>
        <div>
          <a-button @click="settleHideIs = false">
            取消
          </a-button>
          <a-button type="primary" @click="onSubmitSettle">
            确定
          </a-button>
        </div>
      </div>
    </aside>
    <!-- 结算 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      rejectIsShow: false,
      reason: "",
      settleHideIs: false,
      reward_guard: "",
      punish_guard: "",
      reward_owner: "",
      punish_owner: "",
      check_remark: "",
      add_goods_before_img: [],
      add_goods_after_img: [],
      device_all_img: [],
      meichen_img: [],
      clean_after_img: []
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    onSubmitSettle() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Work_order/checkPrice";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: this.detail.id,
        reward_owner: this.reward_owner,
        reward_guard: this.reward_guard,
        punish_owner: this.punish_owner,
        punish_guard: this.punish_guard,
        check_remark: this.check_remark
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
            this.settleHideIs = false;
            this.$emit("hideIsDetail", true);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错了...");
        });
    },
    setSettle() {
      this.settleHideIs = true;
    },
    getDetail() {
      this.detail = this.detailVal;
      this.reward_owner = this.detail.reward_owner;
      this.reward_guard = this.detail.reward_guard;
      this.punish_owner = this.detail.punish_owner;
      this.punish_guard = this.detail.punish_guard;
      this.check_remark = this.detail.check_remark;
      // console.log(this.detail);
    },
    auditPagePass() {
      let _this = this;
      this.$confirm({
        title: "审核工单",
        content: "一旦确定，库存进行自动校正，是否确认操作!",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          _this.orderPassOperation();
        },
        onCancel() {}
      });
    },
    orderPassOperation() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "work_order/checkorderpass";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.detail.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("审核成功");
            this.$emit("hideIsDetail", true);
          } else {
            this.$info({
              title: "提示",
              content: res.data.message,
              onOk() {}
            });
          }
        })
        .catch(err => {});
    },
    auditPageReject() {
      this.rejectIsShow = true;
    },
    rejectSure() {
      this.rejectIsShow = false;
      if (this.reason != "" && this.reason != null) {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "work_order/checkorderreject";
        axios
          .post(url, {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.detail.id,
            reason: this.reason
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success("已驳回");
              this.$emit("hideIsDetail", true);
            } else {
              this.$message.info(res.data.message);
            }
          })
          .catch(err => {});
      } else {
        this.$message.info("请填写驳回原因");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  position: relative;
  .kyFormList {
    h3,
    h2 {
      font-size: 14px;
      line-height: 24px;
    }
  }
  .imgStyle {
    li {
      // display: inline-block;
      // width: 30%;
      img {
        height: 100px;
        width: 100px;
        object-fit: cover;
        margin-right: 20px;
      }
    }
  }
  ul {
    li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  h2 {
    font-style: normal;
    font-size: 14px;
    margin: 30px 0 10px;
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
  .settleStyle {
    ul {
      li {
        display: inline-block;
        width: 50%;
      }
    }
  }
  .operation {
    position: absolute;
    right: 30px;
    top: 20px;
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 16px;
    }
  }
  .dialogsBox {
    > div {
      margin: 20px auto;
      width: 550px;
      text-align: left;
      ul {
        li {
          display: inline-block;
          width: 50%;
        }
      }
    }
  }
}
</style>
